/**
 * Dismisses the available-products redemption outcome modal via the close
 * button, the Back button or a click on the overlay background. Removes the
 * whole overlay, which would otherwise keep blocking the page underneath.
 */
export const initAvailableProductsModal = () => {
  const overlay = document.getElementById('available-products-modal');
  if (!overlay) return;

  const closeModal = () => overlay.remove();

  document.getElementById('available-products-modal-close')?.addEventListener('click', closeModal);
  document.getElementById('available-products-modal-back')?.addEventListener('click', closeModal);

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closeModal();
  });
};
